var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0_14092_3677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_14092_3677",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14092_3677",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14092_3677",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABDlJREFUeF7tnb9OVEEUxs/cxYpojDHRYEdyL9FbrCXR2sKKYGF8Dl5A7Kx8DwqT7XgCEuwkYU3Yu61KDA0YrWDHrEKyXC57zt2ZOTuDH+38Od98vznz7xIwFOBneflx3ulk74noBRHdroX4aYzdJrq1MRjsfQ0Q3rnLeeo3zuprHZwPZpeI7jF9Hxmz8DQ2KPPW7x1InpcfieiVBLS1tDUc9t9I6mrVmbf+EEBOGpapa/y0x1X15a6W2ZI4eV7OVX8IIHZy4FXVvxQjz8up5RLTQtbh9HHlrtoApOYgZzhXDiCuDgAIlqxpc6hxySqKsktE76ylVSJ64DIJuT3EpW+Ntr71G0OHRPSJiN4OBv29+hiuABnDsJZ2iGjRx4B9D8iHpjZ9BNT/yxh6XofSBKRnLa21ET2tbsAB+ZI4tZ+Q+q01veFwf31SwBUgeV6OU8ppmWpz7FVx1SFISCBE9KOq+pe8bgLidE/gjoVcuYN3Xppy+rhyTgTXHkCUj70Awk1ZAPm/7yHzyJBjIrojm5hRPi4G1a8OpCiebFlrXkuAxPj8Hlr/HIB0H1l7+pmI7jNQjrLstHtwcPBNAk+rTlGE1a8OZGzcysrK0tnZwgdj6GXD8nViLW13OqcbscG4gB5S/1yAaM3mFOMASGTUAARAInMgMjnIEACJzIHI5DhnSGTjuXFy6s/77GvvjXMgsgEBCIBE5kBkclpnSL1BZONJTo7zpg4gfpkDiF8/nXsDEGcL/XYAIH79dO4NQJwt9NsBgPj107k3AHG20G8H6kDqAf0OJ77e2l4LACQwQwAJbHDb7gGkrWOB6ycHRCqYW1uv8zWVdhf6Ob3s9xCpodKAqRvLGcolJNceQM4dlE48zlAAmfEPEcxq7KztpCsIMgQZ0pzUs868VNohQ5jFXBskgADIPwe0Z14q8ZAhyJDmDOHO5amXS+8v0WRI6oZz+gGEc0i5HECUDefCJQdEKjiV09KsOqPZQwDkco5xQPGWhbcsvGVNOhD8t9+5lMQHqul/fAdLFpYsLFlYshrmgPbSimMvHhfx/M7d6iWfJ4Jv6hKRKdeRXnyjWbJSNluiHUAkLinWARBFsyWhkgMiFax9DNWOF80eAiB47RX9GydkSGQXNQABkL8OcBMh+MUQewj2EOwhk3OAS0l8oMIHqsY5oD1xcA+J7BARDRDJ80PKdaSHFgBRogwgSkZLwwCI1CmletEDUfIh2TDc6c77TT1Zp5SEA4iS0dIwACJ1SqkegCgZLQ0DIFKnlOoBiJLR0jAAInVKqd4sQLz+g3ulcaYa5ntV9ZcmxV+5hxRF2bOW1lIdYUq6rTW94XB/nQPStZZ2iGgxpcElqPW3MfRsMOjvTQUyLiyKsjsamc0ss6vW0sMEBxutZGPocDQyu1lmN+swxqJF35+jHd0NFAYgkUEFEACJzIHI5PwBX4dsv4xQJ7MAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.13a846a4cc718162505dc633f592242a.svg";
export { ForwardRef as ReactComponent };